import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./dmcLocker.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.dmcLockerAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getDmcPoolInfosAddress = () => {
    return contractAddress;
}

const getDmcPoolInfosContract = () => {
    return contractConst.contract;
}

const getDmcLockPoolInfos = ([_pid], options) => {
    return $web3js.call(getDmcPoolInfosContract().methods.getPoolInfo, [_pid], options, handLockMiningPoolInfo);
}

const handLockMiningPoolInfo = async(res) => {

    // uint256     pid;
    // uint256     masterPid;
    // uint256     lockedDays;//质押天数
    // uint256     startTime;
    // uint256     startBlock;
    // uint256     limitCount;//每天限制次数
    // uint256     depositAmount;//总存入数量
    // uint256     withdrawAmount;//已经提取的本金
    // address     pledgeToken;//质押token地址
    // uint256     withdrawnBenefit;//已经提现的收益

    let index = 0;
    let pid = res[index++];
    let masterPid = res[index++];
    let lockedDays = res[index++];
    let startTime = res[index++];
    let startBlock = res[index++];
    let limitCount = res[index++];
    let depositAmount = res[index++];
    let withdrawAmount = res[index++];
    let pledgeToken = res[index++];
    let withdrawnBenefit = res[index++];


    depositAmount = await $erc20.fromErc20Value(depositAmount, pledgeToken);
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, pledgeToken);
    withdrawnBenefit = await $erc20.fromErc20Value(withdrawnBenefit, pledgeToken);
    return {
        pid,
        lockedDays,
        limitCount,
        depositAmount,
        withdrawAmount,
        withdrawnBenefit,
        pledgeToken
    };
};

const getLockDmcMasterPoolInfo = ([_pid], options) => {
    return $web3js.call(getDmcPoolInfosContract().methods.getMasterPoolInfo, [_pid], options, handLockDmcMasterPoolInfo);
}


const handLockDmcMasterPoolInfo = async(res) => {
    let index = 0;
    let rate = res[index++];
    let amount = res[index++];
    let apy = res[index++];

    amount = await $erc20.fromErc20Value(amount, $erc20.getErc20Address("DMC"));
    return {
        rate,
        amount,
        apy
    };
};


const getDmcLockerUserlimitTimes = ([_user, _pid], options) => {
    return $web3js.call(getDmcPoolInfosContract().methods.getUserlimitTimes, [_user, [_pid]], options);
}


const getdmcLockerUserInfo = ([_user, _pid], options) => {
    return $web3js.call(getDmcPoolInfosContract().methods.getUserInfos, [_user, [_pid]], options, handDmcLockerUserInfo);
}
const handDmcLockerUserInfo = async(res) => {
    // uint256 pid;
    // uint256 lockedDays; //质押天数
    // uint256 lockedTimes;
    // uint256 withdrawIndex;
    // uint256 depositAmount; //总存入数量
    // uint256 withdrawAmount; //已经提取的本金
    // uint256 availAmount; //可以领取的本金
    // uint256 withdrawnBenefit; //已经提现的收益
    // uint256 availBenefit; //可领取的收益
    let res2 = res[0]
    let index = 0;
    let pid = res2[index++];
    let lockedDays = res2[index++];
    let lockedTimes = res2[index++];
    let withdrawIndex = res2[index++];
    let depositAmount = res2[index++];
    let withdrawAmount = res2[index++];
    let availAmount = res2[index++];
    let withdrawnBenefit = res2[index++];
    let availBenefit = res2[index++];

    depositAmount = await $erc20.fromErc20Value(depositAmount, $erc20.getErc20Address("DMC"));
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, $erc20.getErc20Address("DMC"));
    availAmount = await $erc20.fromErc20Value(availAmount, $erc20.getErc20Address("DMC"));
    availBenefit = await $erc20.fromErc20Value(availBenefit, $erc20.getErc20Address("DMC"));
    withdrawnBenefit = await $erc20.fromErc20Value(withdrawnBenefit, $erc20.getErc20Address("DMC"));
    return {
        lockedTimes,
        depositAmount,
        withdrawAmount,
        availAmount,
        availBenefit,
        withdrawnBenefit
    };
};

const dmcLockerUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getDmcPoolInfosContract().methods.lock, [_pid, _amount], options, callback);
};

const dmcLockerUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    let gasPromise = $web3js.estimateSend(getDmcPoolInfosContract().methods.lock, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}



const dmcLockerWithdraw = ([_pid], options, callback) => {
    return $web3js.send(getDmcPoolInfosContract().methods.withdraw, [_pid], options, callback);
};

const dmcLockerWithdrawEstimateSend = async([_pid], options) => {
    let gasPromise = $web3js.estimateSend(
        getDmcPoolInfosContract().methods.withdraw, [_pid], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

export default {
    getDmcPoolInfosAddress,
    getDmcPoolInfosContract,
    getDmcLockPoolInfos,
    dmcLockerUserDeposit,
    dmcLockerUserDepositEstimateSend,
    getdmcLockerUserInfo,
    dmcLockerWithdraw,
    dmcLockerWithdrawEstimateSend,
    getLockDmcMasterPoolInfo,
    getDmcLockerUserlimitTimes
}


// WEBPACK FOOTER //
// ./src/lib/contract/dmcLocker/index.js